module.exports = __webpack_public_path__ + "img/programme7.76d5fbad.png";